import React, { useEffect, useRef, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import addBtn from "../../assets/icons/Add Assignee.svg";
import bin from "../../assets/icons/Bin - Copy.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import searchicon from "../../assets/icons/search.svg";
import tool from "../../assets/icons/tool.svg";
import calender from "../../assets/images/Calendar3.svg";
import "../../assets/styles/local/Equipment.css";
import AppDatePicker from "../../components/Common/AppDatePicker";
import EquipmentModal from "../../components/Dailogs/EquipmentModal";
import Header from "../../layouts/Header";
import {
  addEquipment,
  fetchDrivers,
  fetchEquipment,
  updateEquipment,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import EquipmentImagesBB from "./EquipmentImagesBB";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { ROLES } from "../../utils/helpers/userRole";
import CurrencyInput from "react-currency-input";

const EquipmentDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const roleAccess = window.localStorage.getItem("roleid");
  const history = useHistory();
  const modalRef = useRef(null);
  const [activeTab, setActiveTab] = useState("General");
  const [startDate, setStartDate] = useState(null);
  const [DataTemp, setDataTemp] = useState(null);
  const [dateError, setDateError] = useState(false);
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [fromCalendarIsOpen, setFromCalendarIsOpen] = useState(false);
  const [toCalendarIsOpen, setToCalendarIsOpen] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [projectListTranslation, setProjectListTranslation] = useState({});
  const t = (key) => projectListTranslation?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Equipment").then((res) => {
      setProjectListTranslation(res);
    });
  }, []);

  const datePickerFunc = (val) => {
    setEquipmentData({ ...equipmentData, acquisition: val });
    setCalendarIsOpen(!calendarIsOpen);
  };

  const datePickerFuncFrom = (val) => {
    setDataTemp({
      ...DataTemp,
      from: val,
    });
    setFromCalendarIsOpen(false);
  };
  const datePickerFuncTo = (val) => {
    setDataTemp({
      ...DataTemp,
      to: val,
    });
    setToCalendarIsOpen(false);
  };

  const [equipmentData, setEquipmentData] = useState({ isavailable: 1 });
  // const [createEquipmentData, setCreateEquipmentData] = useState({});
  const fetchEquipmentData = async (id) => {
    const data = await fetchEquipment(id);
    setEquipmentData(data);
    setUnavailable(data?.equipmentavailabilities || []);
  };
  const [drivers, setDrivers] = useState([]);
  const [driversToRender, setDriversToRender] = useState([]);
  const [search, setsearch] = useState("");

  useEffect(() => {
    if (search.length && search.trim() !== "") {
      const tempDriver = drivers?.filter((driver) =>
        driver?.username.toLowerCase().includes(search.trim().toLowerCase()),
      );
      setDriversToRender(tempDriver);
    } else {
      setDriversToRender(drivers);
    }
  }, [search]);
  const companyId = window.localStorage.getItem("companyid");

  const fetchDriver = async () => {
    const data = await fetchDrivers(companyId);
    setDrivers(data?.data?.data);
    setDriversToRender(data?.data?.data);
  };

  const [CancelModal, setCancelModal] = useState(false);

  useEffect(() => {
    fetchDriver();
    if (id) {
      fetchEquipmentData(id);
    }
  }, [id, companyId]);

  // useEffect(() => {
  //   if (equipmentData) {
  //     setCreateEquipmentData({ ...equipmentData })
  //   }
  // }, [equipmentData])

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowSearchModal(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);
  const removeImage = (image) => {
    let dataTemp = {
      ...equipmentData,
      equipmentimages: equipmentData?.equipmentimages?.filter(
        (item) => item?.image !== image?.image,
      ),
    };
    setEquipmentData(dataTemp);
  };
  const [loadingImage, setLoadingImage] = useState(false);
  const handleFileChange = (e) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);
    setLoadingImage(true);
    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          let dataTemp = {
            ...equipmentData,
            equipmentimages:
              typeof equipmentData?.equipmentimages === "object"
                ? [
                    ...equipmentData?.equipmentimages,
                    { image: response.data[0] },
                  ]
                : [{ image: response.data[0] }],
          };
          setEquipmentData(dataTemp);
          setLoadingImage(false);
        } else {
          setLoadingImage(false);
        }
      })
      .catch(function (error) {});
    // alert(target.name + " " + "File is Attached in comment box");
  };
  const handleFileChange1 = (e) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);

    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          let dataTemp = {
            ...equipmentData,
            picture: response.data[0],
          };
          setEquipmentData(dataTemp);
        } else {
        }
      })
      .catch(function (error) {});
  };

  // asc bydefault available toggle is on. start

  // useEffect(() => {
  //   setEquipmentData({
  //     ...equipmentData,
  //     isavailable: equipmentData?.isavailable !== 0 ? 1 : 0,
  //   });
  // }, []);
  // asc bydefault available toggle is on. end

  const createEquipments = () => {
    let err = false;
    if (
      !equipmentData?.equipmentname ||
      equipmentData?.equipmentname?.trim() === ""
    ) {
      setError((prev) => ({ ...prev, name: "Name is required" }));
      err = true;
    }
    if (
      !equipmentData?.equipmentcode ||
      equipmentData?.equipmentcode?.trim() === ""
    ) {
      setError((prev) => ({ ...prev, internalId: "Internal Id is required" }));
      err = true;
    }
    if (err) {
      return;
    }
    let newData = unavailable.map(({ fromOpen, toOpen, ...rest }) => rest);

    addEquipment({
      ...equipmentData,
      driverid: "08dae7e3-f555-4ac8-8616-28914254bdda",
      equipmentavailabilities: newData,
      timeUnit: equipmentData?.timeUnit || "",
      timeUnitPrice: (equipmentData?.timeUnitPrice ?? 0)
        .toString()
        .replace(".", ","),
    }).then((res) => {
      history.push("/equipment");
    });
  };

  const updateEquipments = () => {
    let err = false;
    if (
      !equipmentData?.equipmentname ||
      equipmentData?.equipmentname?.trim() === ""
    ) {
      setError((prev) => ({ ...prev, name: "Name is required" }));
      err = true;
    }
    if (
      !equipmentData?.equipmentcode ||
      equipmentData?.equipmentcode?.trim() === ""
    ) {
      setError((prev) => ({ ...prev, internalId: "Internal Id is required" }));
      err = true;
    }
    if (err) {
      return;
    }
    let newData = unavailable.map(({ fromOpen, toOpen, ...rest }) => rest);
    updateEquipment({
      ...equipmentData,
      plateno: equipmentData?.platenumber,
      equipmentavailabilities: newData,
      isTemporaryUnavailable: unavailable?.length > 0 ? true : false,

      timeUnit: equipmentData?.timeUnit || "",
      timeUnitPrice: (equipmentData?.timeUnitPrice ?? 0)
        .toString()
        .replace(".", ","),
    }).then((res) => {
      history.push("/equipment");
    });
  };

  useEffect(() => {
    if (
      equipmentData?.equipmentname &&
      equipmentData?.equipmentname?.trim() !== ""
    ) {
      setError((prev) => ({ ...prev, name: "" }));
    }
    if (
      equipmentData?.equipmentcode &&
      equipmentData?.equipmentcode?.trim() !== ""
    ) {
      setError((prev) => ({ ...prev, internalId: "" }));
    }
  }, [equipmentData]);

  const [error, setError] = useState({ name: "", internalId: "" });

  const getInitials = (name = "") =>
    name
      .split(" ")
      .map((w) => w[0])
      .slice(0, 2)
      .join("")
      .toUpperCase();

  useEffect(() => {
    if (equipmentData?.equipmentDrivers?.length > 0) {
      let equipDrivers = equipmentData?.equipmentDrivers?.map((it, index) => {
        return {
          ...it,
          // status: "default",
          status: index === 0 ? "default" : it.status || "",
        };
      });

      // we insert changed co-worker start
      setDrivers((prev) => {
        const nonDuplicateDrivers = equipDrivers.filter(
          (d) =>
            !prev.some(
              (p) => p.driverid === d.driverid || p.userid === d.driverid,
            ),
        );

        const updatedDrivers = nonDuplicateDrivers.map((d) => ({
          userid: d.driverid,
          username: d.drivername,
          userimage: d.driverimage,
          userinitials: getInitials(d.drivername),
        }));

        return [...prev, ...updatedDrivers];
      });
      // we insert changed co-worker end
    }
  }, [equipmentData]);

  // we can delete all multiple drivers with default also👇
  // const defaultStatusSet = useRef(false); // ek baar hi "default" set karne ke liye

  // useEffect(() => {
  //   if (
  //     !defaultStatusSet.current &&
  //     equipmentData?.equipmentDrivers?.length > 0
  //   ) {
  //     let equipDrivers = equipmentData.equipmentDrivers.map((it, index) => {
  //       return {
  //         ...it,
  //         status: index === 0 ? "default" : it.status || "",
  //       };
  //     });

  //     setEquipmentData({ ...equipmentData, equipmentDrivers: equipDrivers });
  //     defaultStatusSet.current = true; // ab dobara nahi chalega
  //   }
  // }, [equipmentData.equipmentDrivers]);
  // we can delete all multiple drivers with defaulsy also👆

  const pictureinput = useRef(null);
  const [unavailable, setUnavailable] = useState([]);
  const [touched, setTouched] = useState(false);
  const [color, setColor] = useState([]);
  const [model, setModel] = useState([]);
  const fetchColor = async () => {
    axios
      .get(`${API_URL}/api/User/GetSuggestedModel`)
      .then((response) => {
        setModel(response?.data?.data);
      })
      .catch(() => {});
    axios
      .get(`${API_URL}/api/User/GetSuggestedColor`)
      .then((response) => {
        setColor(response?.data?.data);
      })
      .catch(() => {});
  };
  useEffect(() => {
    fetchColor();
  }, []);

  useEffect(() => {
    const inputs = document.querySelectorAll("input");

    inputs.forEach((input) => {
      input.addEventListener("change", () => {
        setTouched(true);
      });
    });
  }, []);
  const [showModelOptions, setShowModelOptions] = useState(false);
  const [showColorOptions, setShowColorOptions] = useState(false);
  const [showBrandXIcon, setShowBrandXIcon] = useState(false);
  const [colorShowBrandXIcon, setColorShowBrandXIcon] = useState(false);
  console.log("asc26 unavailable dates", unavailable);

  return (
    <>
      <Header
        leftComponent={
          <div
            className="flex-wrap d-flex align-items-baseline"
            style={{ gap: "20px" }}
          >
            <div
              className="projectText2"
              onClick={() => {
                history.push("/equipment");
              }}
              style={{
                marginTop: "0px",
                fontSize: "16px",
                color: "#333333",
              }}
            >
              {/* Equipment */}
              {t("Equipment")}
            </div>
            <div className="head-white-bg">
              {/* {id ? "File" : "New Equipment - file"} */}
              {id ? t("File") : t("New Equipment - file")}
            </div>
          </div>
        }
      />
      <div className="equip-btns-main">
        <button
          className="products-and-parts-cancle-btn-aspect-ratio"
          style={{ wordBreak: "break-all" }}
          onClick={() => {
            setCancelModal(true);
            if (!touched) {
              history.push("/equipment");
            }
          }}
        >
          {/* Cancel */}
          {t("Cancel")}
        </button>
        {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
          <button
            className="invitebtn-update products-and-parts-invite-btn-aspect-ratio"
            style={{
              wordBreak: "break-all",
              borderRadius: "12px",
              cursor: "pointer",
            }}
            onClick={() => {
              if (id) {
                updateEquipments();
              } else {
                createEquipments();
              }
            }}
          >
            {/* {id ? "Update" : "Add"} */}
            {id ? t("Change") : t("Add")}
          </button>
        )}
      </div>
      <div style={{ padding: "0 36.35px 0 24px", marginTop: "22px" }}>
        <div className="equip-white-box">
          <div
            className={
              roleAccess === ROLES.VIEWER
                ? "equip-main-items after_eventPop"
                : "equip-main-items"
            }
          >
            <div
              onClick={() => pictureinput.current.click()}
              className="equip-medium-input-box-image equip-picture-box"
            >
              <input
                multiple
                type="file"
                accept="image/*"
                ref={pictureinput}
                style={{ display: "none" }}
                onChange={(e) => {
                  handleFileChange1(e);
                }}
              />
              <img
                src={equipmentData?.picture || tool}
                alt=""
                style={{
                  borderRadius: "clamp(8px, 0.586vw, 0.586vw)",
                  height: equipmentData?.picture && "100%",
                  width: equipmentData?.picture && "100%",
                  objectFit: "contain",
                }}
              />
              {!equipmentData?.picture && (
                <p className="equip-picture-text">
                  {/* Picture */}
                  {t("Picture")}
                </p>
              )}
            </div>
            <div
              className={`equip-medium-input-box  ${
                error?.name && "equip-medium-input-box-error"
              }`}
              style={{ position: "relative" }}
            >
              <label
                className={`equip-box-label  ${
                  error?.name && "equip-box-label-error"
                }`}
              >
                {/* Item Name * */}
                {`${t("Item Name")} *`}
              </label>
              <input
                className="equip-medium-input"
                // placeholder="Add a name"
                placeholder={t("Add a name")}
                defaultValue={equipmentData?.equipmentname}
                onChange={(e) =>
                  setEquipmentData({
                    ...equipmentData,
                    equipmentname: e.target.value,
                  })
                }
              />
            </div>
            <div
              className="equip-medium-input-box"
              style={{ position: "relative" }}
            >
              <label className="equip-box-label">
                {/* Plate No. */}
                {t("Plate No")}
              </label>
              <input
                defaultValue={
                  equipmentData?.platenumber || equipmentData?.plateno
                }
                onChange={(e) =>
                  setEquipmentData({
                    ...equipmentData,
                    plateno: e.target.value,
                    platenumber: e.target.value,
                  })
                }
                className="equip-medium-input"
                // placeholder="Add a number"
                placeholder={t("Add a number")}
              />
            </div>
            <div
              className={`equip-medium-input-box  ${
                error?.internalId && "equip-medium-input-box-error"
              }`}
              style={{ position: "relative" }}
            >
              <label
                className={`equip-box-label  ${
                  error?.internalId && "equip-box-label-error"
                }`}
              >
                {/* Internal ID * */}
                {`${t("Internal Id")} *`}
              </label>
              <input
                value={equipmentData?.equipmentcode}
                onChange={(e) =>
                  setEquipmentData({
                    ...equipmentData,
                    equipmentcode: e.target.value,
                  })
                }
                className="equip-medium-input"
                // placeholder="Add an ID"
                placeholder={t("Add an ID")}
              />
            </div>
          </div>
        </div>
        <div className="equip-box-2">
          <div className="equip-nav">
            <div
              className="equip-nav-back"
              style={{
                left:
                  activeTab === "General"
                    ? "0"
                    : activeTab === "Images"
                      ? "33%"
                      : "67%",
              }}
            ></div>
            <div
              className="equip-nav-line"
              style={{
                left:
                  activeTab === "General"
                    ? "4%"
                    : activeTab === "Images"
                      ? "37%"
                      : "71%",
              }}
            ></div>
            <p
              className="equip-nav-text"
              style={{
                fontWeight: activeTab === "General" ? "700" : "400",
                color: activeTab === "General" ? "#2B1710" : "#7E7E7E",
                opacity: activeTab === "General" ? "1" : "0.6",
              }}
              onClick={() => setActiveTab("General")}
            >
              {t("General")}
              {/* {projectListTranslation[48]?.translation} */}
            </p>
            <p
              className="equip-nav-text px-3"
              style={{
                fontWeight: activeTab === "Images" ? "700" : "400",
                color: activeTab === "Images" ? "#2B1710" : "#7E7E7E",
                opacity: activeTab === "Images" ? "1" : "0.6",
              }}
              onClick={() => setActiveTab("Images")}
            >
              {t("Images")}
              {/* {projectListTranslation[27]?.translation} */}
            </p>
            <p
              className="equip-nav-text"
              style={{
                fontWeight: activeTab === "Availability" ? "700" : "400",
                color: activeTab === "Availability" ? "#2B1710" : "#7E7E7E",
                opacity: activeTab === "Availability" ? "1" : "0.6",
              }}
              onClick={() => setActiveTab("Availability")}
            >
              {t("Availability")}
              {/* {projectListTranslation[49]?.translation} */}
            </p>
          </div>
        </div>
        <div className="equip-box-3">
          <div
            className={
              roleAccess === ROLES.VIEWER
                ? "equip-box-general after_eventPop"
                : "equip-box-general"
            }
            style={{
              left:
                activeTab === "General"
                  ? "0"
                  : activeTab === "Images"
                    ? "-100%"
                    : "-200%",
              color: "white",
            }}
          >
            <div className="equip-general-1">
              <div
                className="equip-medium-input-box equip-textarea-box"
                style={{ position: "relative" }}
              >
                <label className="equip-box-label" style={{ top: "-4%" }}>
                  {/* Item Name */}
                  {t("Item Name")}
                </label>
                <div
                  style={{ width: "98%", height: "98%", overflow: "hidden" }}
                >
                  <textarea
                    className="equip-medium-input equip-textarea"
                    // placeholder="Add a description"
                    placeholder={t("Add a description")}
                    defaultValue={equipmentData?.itemdescription}
                    onChange={(e) =>
                      setEquipmentData({
                        ...equipmentData,
                        itemdescription: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div
                className="equip-medium-input-box"
                style={{ position: "relative" }}
              >
                <label className="equip-box-label">
                  {/* Acquisition Date */}
                  {t("Acquisition Date")}
                </label>
                <img
                  src={calender}
                  alt="calender"
                  style={{
                    marginLeft: "10px",
                    marginRight: "17px",
                  }}
                  onClick={() => setCalendarIsOpen(!calendarIsOpen)}
                />
                <div id="CalendarCssAT">
                  <AppDatePicker
                    open={calendarIsOpen}
                    onOpenChange={(open) => setCalendarIsOpen(open)}
                    selected={
                      equipmentData?.acquisition
                        ? new Date(equipmentData?.acquisition)
                        : null
                    }
                    onChange={datePickerFunc}
                    dateFormat="dd/MM/yyyy"
                    isError={dateError}
                    error={setDateError}
                    onSelect={(d, event) => {
                      setStartDate(d);
                      setDateError(false);
                      event.preventDefault();
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="equip-general-2">
              <div
                className="equip-medium-input-box equip-dimen-box"
                style={{ position: "relative" }}
              >
                <label className="equip-box-label" style={{ top: "-10%" }}>
                  {/* Dimensions (mm) */}
                  {t("Dimensions (mm)")}
                </label>
                <div className="single-dimen">
                  <input
                    onChange={(e) =>
                      setEquipmentData({
                        ...equipmentData,
                        width: e.target.value,
                      })
                    }
                    className="single-dimen-input"
                    placeholder="0"
                    defaultValue={equipmentData?.width}
                  />
                  <p className="single-dimen-text">
                    {/* Width */}
                    {t("Width")}
                  </p>
                </div>
                <div className="single-dimen">
                  <input
                    onChange={(e) =>
                      setEquipmentData({
                        ...equipmentData,
                        heigth: e.target.value,
                      })
                    }
                    className="single-dimen-input"
                    placeholder="0"
                    defaultValue={equipmentData?.heigth}
                  />
                  <p className="single-dimen-text">
                    {/* Height */}
                    {t("Height")}
                  </p>
                </div>
                <div className="single-dimen">
                  <input
                    onChange={(e) =>
                      setEquipmentData({
                        ...equipmentData,
                        depth: e.target.value,
                      })
                    }
                    className="single-dimen-input"
                    placeholder="0"
                    defaultValue={equipmentData?.depth}
                  />
                  <p className="single-dimen-text">
                    {/* Depth */}
                    {t("Depth")}
                  </p>
                </div>
              </div>

              <div className="d-flex gap-3 w-100 mt-2">
                <div className="production-field w-10-0">
                  <label>{t("Time unit")}</label>
                  <select
                    value={equipmentData.timeUnit}
                    onChange={(e) =>
                      setEquipmentData({
                        ...equipmentData,
                        timeUnit: e.target.value,
                      })
                    }
                  >
                    <option value="">Select</option>
                    <option value="Minutes">Minutes</option>
                    <option value="One-Off">One-Off</option>
                  </select>
                </div>

                <div className="production-field w-10-0">
                  <label>{t("Time Unit Price")}</label>
                  <CurrencyInput
                    className="products-and-parts-stock-inputs products-and-parts-lead-time-input text-start"
                    placeholder="0"
                    name="costprice"
                    value={equipmentData.timeUnitPrice}
                    onChange={(e, value) =>
                      setEquipmentData({
                        ...equipmentData,
                        timeUnitPrice: value,
                      })
                    }
                    decimalSeparator=","
                    thousandSeparator="."
                    precision="2"
                    allowEmpty={true}
                    prefix="€ "
                    // style={{
                    //   border: fieldErrors?.[index]?.costprice
                    //     ? "1px solid red"
                    //     : "",
                    // }}
                  />
                </div>
              </div>

              {/* <div
                className="equip-medium-input-box"
                style={{ position: "relative" }}>
                <label className="equip-box-label">Model</label>
                <input
                  defaultValue={equipmentData?.model}
                  onChange={(e) =>
                    setEquipmentData({
                      ...equipmentData,
                      model: e.target.value,
                    })
                  }
                  className="equip-medium-input"
                  placeholder="Add a model"
                />
              </div> */}
              <div
                className="products-and-parts-asc-input-container-general-section-2"
                style={{ marginTop: "8px" }}
                id="products-and-parts-ascInput"
              >
                <label
                  className="products-and-parts-asc-label-top products-and-parts-item-brand-title"
                  style={{ zIndex: 1 }}
                >
                  {/* Model */}
                  {t("Model")}
                </label>
                <div
                  className={`w-100 ${
                    showModelOptions
                      ? "products-and-parts-tab-brand-input-expanded ps-3"
                      : "products-and-parts-tab-brand-input ps-3"
                  }`}
                >
                  <input
                    type="text"
                    placeholder={`${
                      showModelOptions ? "Add a model" : "Model"
                    }`}
                    className="products-and-parts-brand-text"
                    value={equipmentData?.model}
                    name="brand"
                    onChange={(e) => {
                      setEquipmentData({
                        ...equipmentData,
                        model: e.target.value,
                      });
                      setShowBrandXIcon(true);
                    }}
                    onFocus={() => setShowModelOptions(true)}
                    onBlur={() =>
                      setTimeout(() => setShowModelOptions(false), 300)
                    }
                  />

                  {showBrandXIcon && (
                    <img
                      src={Xicon}
                      className="pointer"
                      alt=""
                      onClick={() => {
                        setEquipmentData({
                          ...equipmentData,
                          model: "",
                        });
                        setShowModelOptions(false);
                        setShowBrandXIcon(false);
                      }}
                    />
                  )}

                  {showModelOptions && (
                    <div className="products-and-parts-brand-customSelect_Outer">
                      {model
                        .filter((i) =>
                          equipmentData?.model
                            ? i
                                .toLowerCase()
                                .includes(
                                  equipmentData?.model?.toLocaleLowerCase(),
                                )
                            : true,
                        )
                        .map((item, index) => {
                          return (
                            <div
                              key={index}
                              name="brand"
                              className="products-and-parts-pointer products-and-parts-dropdown-spacing ulterDrop"
                              onClick={() => {
                                setEquipmentData({
                                  ...equipmentData,
                                  model: item,
                                });
                                setShowModelOptions(false);
                                setShowBrandXIcon(true);
                              }}
                            >
                              {item}
                            </div>
                          );
                        })}
                      {model?.length === 0 && <span>No data to display!</span>}
                    </div>
                  )}
                </div>
              </div>
              {/* <div
                className="equip-medium-input-box"
                style={{ position: "relative" }}>
                <label className="equip-box-label">Color</label>
                <input
                  defaultValue={equipmentData?.color}
                  onChange={(e) =>
                    setEquipmentData({
                      ...equipmentData,
                      color: e.target.value,
                    })
                  }
                  className="equip-medium-input"
                  placeholder="Add a color"
                />
              </div> */}
              <div
                className="products-and-parts-asc-input-container-general-section-2"
                style={{ marginTop: "8px" }}
                id="products-and-parts-ascInput"
              >
                <label
                  className="products-and-parts-asc-label-top products-and-parts-item-brand-title"
                  style={{ zIndex: 1 }}
                >
                  {/* Color */}
                  {t("Color")}
                </label>
                <div
                  className={`w-100 ${
                    showColorOptions
                      ? "products-and-parts-tab-brand-input-expanded ps-3"
                      : "products-and-parts-tab-brand-input ps-3"
                  }`}
                >
                  <input
                    type="text"
                    placeholder={`${
                      showColorOptions ? "Add a color" : t("Color")
                    }`}
                    className="products-and-parts-brand-text"
                    value={equipmentData?.color}
                    name="brand"
                    onChange={(e) => {
                      setEquipmentData({
                        ...equipmentData,
                        color: e.target.value,
                      });
                      setColorShowBrandXIcon(true);
                    }}
                    onFocus={() => setShowColorOptions(true)}
                    onBlur={() =>
                      setTimeout(() => setShowColorOptions(false), 300)
                    }
                  />

                  {colorShowBrandXIcon && (
                    <img
                      src={Xicon}
                      className="pointer"
                      alt=""
                      onClick={() => {
                        setEquipmentData({
                          ...equipmentData,
                          color: "",
                        });
                        setShowColorOptions(false);
                        setColorShowBrandXIcon(false);
                      }}
                    />
                  )}

                  {showColorOptions && (
                    <div className="products-and-parts-brand-customSelect_Outer">
                      {color
                        .filter((i) =>
                          equipmentData?.color
                            ? i
                                .toLowerCase()
                                .includes(
                                  equipmentData?.color?.toLocaleLowerCase(),
                                )
                            : true,
                        )
                        .map((item, index) => {
                          return (
                            <div
                              key={index}
                              name="brand"
                              className="products-and-parts-pointer products-and-parts-dropdown-spacing ulterDrop"
                              onClick={() => {
                                setEquipmentData({
                                  ...equipmentData,
                                  color: item,
                                });
                                setShowColorOptions(false);
                                setColorShowBrandXIcon(true);
                              }}
                            >
                              {item}
                            </div>
                          );
                        })}
                      {color.length === 0 && <span>No data to display!</span>}
                    </div>
                  )}
                </div>
              </div>

              <div
                className="equip-medium-input-box"
                style={{ position: "relative", marginTop: "10px" }}
              >
                <label className="equip-box-label">
                  {/* Note */}
                  {t("Notes")}
                </label>
                <div
                  style={{
                    width: "98%",
                    height: "96%",
                    overflow: "hidden",
                    margin: "auto",
                  }}
                >
                  <textarea
                    defaultValue={equipmentData?.notes}
                    onChange={(e) =>
                      setEquipmentData({
                        ...equipmentData,
                        notes: e.target.value,
                      })
                    }
                    className="equip-medium-input equip-textarea"
                  />
                </div>
              </div>
            </div>

            <div className="equip-general-3">
              <div className="equip-driver-cont">
                <label className="equip-box-label" style={{ top: "-12px" }}>
                  {/* Driver */}
                  {t("Driver")}
                </label>
                <div
                  className="selected-driver-list"
                  style={{ marginBottom: "16px" }}
                >
                  {}
                  {drivers?.map((dr) => {
                    let d = {};
                    const isDriverIdExists = (
                      equipmentData?.equipmentDrivers || []
                    ).some((driver) => {
                      if (driver.driverid === dr?.userid) {
                        d = driver;
                      }
                      return driver.driverid === dr?.userid;
                    });
                    if (isDriverIdExists) {
                      return (
                        <div className="s-driver-box">
                          {dr?.userimage !== "" ? (
                            <img
                              alt=""
                              className="driver-list-img"
                              src={dr?.userimage}
                            />
                          ) : (
                            <div className="abbreviation-icon-SM">
                              {/* {dr?.username
                                .split(" ")
                                .map((namePart) => namePart[0])
                                .join("")} */}

                              {dr?.userinitials}
                            </div>
                          )}

                          <p
                            className="driver-list-name"
                            style={{ color: "#333333", flexGrow: "1" }}
                          >
                            {dr?.username}
                          </p>

                          <p
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (d.status !== "default") {
                                let equipDrivers =
                                  equipmentData?.equipmentDrivers?.map((it) => {
                                    if (it.driverid === dr?.userid) {
                                      return {
                                        ...it,
                                        status: "default",
                                      };
                                    }
                                    return {
                                      ...it,
                                      status: "",
                                    };
                                  });
                                setEquipmentData({
                                  ...equipmentData,
                                  equipmentDrivers: equipDrivers,
                                });
                              }
                            }}
                            className="driver-default-text"
                          >
                            {d.status === "default"
                              ? "Default"
                              : "Turn Default"}
                          </p>

                          <img
                            onClick={() => {
                              let equipDrivers =
                                equipmentData?.equipmentDrivers?.filter(
                                  (it) => {
                                    return it.driverid !== dr?.userid;
                                  },
                                );
                              setEquipmentData({
                                ...equipmentData,
                                equipmentDrivers: equipDrivers,
                              });
                            }}
                            alt=""
                            src={bin}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      );
                    }
                    return <></>;
                  })}
                  {/* <div className="s-driver-box">
                    <img
                      alt=""
                      className="s-driver-img"
                      src="https://www.deere.com/assets/images/region-4/industries/agriculture/46r-product-card-r4x001985-rrd-1024x576.jpg"
                    />
                    <p className="driver-list-name" style={{ color: "#333333", flexGrow: "1" }}>
                      Teresa White
                    </p>
                    <p className="driver-default-text" style={{ color: "#A5A5A5" }}>
                      Turn Default
                    </p>
                    <img alt="" src={bin} />
                  </div> */}
                </div>

                <div style={{ position: "relative" }}>
                  <img
                    src={addBtn}
                    alt=""
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowSearchModal(true)}
                  />
                  <div
                    ref={modalRef}
                    className="select-driver-modal"
                    style={{
                      transform: showSearchModal ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <section className="driver-modal-search">
                      <img
                        src={searchicon}
                        alt="Search Icon"
                        style={{
                          flexShrink: "0",
                          width: "17px",
                          height: "17px",
                        }}
                      />
                      <input
                        onChange={(e) => setsearch(e.target.value)}
                        className="quote-modal-input"
                        // placeholder="Search"
                        placeholder={t("Search")}
                      />
                    </section>
                    <section
                      className="quote-modal-list"
                      style={{ maxHeight: "270px" }}
                    >
                      {driversToRender?.map((driver) => {
                        return (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const isDriverIdExists = (
                                equipmentData?.equipmentDrivers || []
                              ).some((dd) => dd.driverid === driver?.userid);
                              if (!isDriverIdExists) {
                                setEquipmentData({
                                  ...equipmentData,
                                  equipmentDrivers: [
                                    ...(equipmentData?.equipmentDrivers || []),
                                    { driverid: driver?.userid, status: "" },
                                  ],
                                });
                              }
                            }}
                            className="driver-box"
                          >
                            {driver?.userimage !== "" ? (
                              <img
                                alt=""
                                className="driver-list-img"
                                src={driver?.userimage}
                              />
                            ) : (
                              <div className="abbreviation-icon-SM">
                                {/* {driver?.username
                                  .split(" ")
                                  .map((namePart) => namePart[0])
                                  .join("")} */}

                                {driver?.userinitials}
                              </div>
                            )}
                            <p className="driver-list-name">
                              {driver?.username}
                            </p>
                          </div>
                        );
                      })}
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={
              roleAccess === ROLES.VIEWER
                ? "equip-box-images after_eventPop"
                : "equip-box-images"
            }
            style={{
              left:
                activeTab === "Images"
                  ? "0"
                  : activeTab === "General"
                    ? "100%"
                    : "-100%",
            }}
          >
            <EquipmentImagesBB
              equipmentData={equipmentData}
              setEquipmentData={setEquipmentData}
            />
            {/* {
              equipmentData?.equipmentimages?.map(item => {
                return (<div className="equip-img-cont">
                  <div className="equip-img-box">
                    <img
                      alt=""
                      className="equip-cover-img"
                      src={item?.image}
                    />
                  </div>
                  <div className="equip-cover-box">
                    <p className="cover-text">Cover Image</p>
                    <img
                      alt=""
                      onClick={() => removeImage(item)} src={bin} style={{ cursor: "pointer" }} />
                  </div>
                </div>)
              })
            }
            {loadingImage &&
              <div className="equip-img-cont">
                <div className="equip-img-box" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <img
                    alt=""
                    style={{ width: "auto", height: "100%" }}
                    className="equip-cover-img"
                    src="https://www.clipartmax.com/png/full/219-2195560_loading-image-blue-loading-animated-gif.png"
                  />
                </div>

              </div>}
            <div className="equip-add-cont" onClick={() => hidden_Input_File.current.click()}>
              <div className="equip-add-box" style={{ marginRight: "0" }}>
                <input
                  multiple
                  type="file"
                  accept="image/*"
                  ref={hidden_Input_File}
                  style={{ display: "none" }}

                  onChange={(e) => {
                    handleFileChange(e);
                  }}
                />
                <FaPlus style={{ color: "#70707080", fontSize: "12px", cursor: "pointer" }} />
              </div>
            </div> */}
          </div>

          <div
            className={
              roleAccess === ROLES.VIEWER
                ? "equip-box-avail after_eventPop"
                : "equip-box-avail"
            }
            style={{
              left:
                activeTab === "Availability"
                  ? "0"
                  : activeTab === "Images"
                    ? "100%"
                    : "200%",
            }}
          >
            <div className="avail-box-top">
              <p className="available-text">
                {/* Available? */}
                {t("Available?")}
              </p>
              <article
                className="task-slider"
                style={{
                  backgroundColor:
                    Boolean(equipmentData?.isavailable !== 0) && "#00246A",
                }}
                onClick={() => {
                  setEquipmentData({
                    ...equipmentData,
                    isavailable: equipmentData?.isavailable === 0 ? 1 : 0,
                  });
                  console.log("asc24", equipmentData);
                  console.log("asc25 avai", equipmentData.isavailable);
                }}
              >
                <article
                  className="task-slider-knob"
                  style={{
                    left: Boolean(equipmentData?.isavailable !== 0) && "46%",
                  }}
                ></article>
              </article>
            </div>
            <div className="unavail-box">
              <p className="unavail-text">
                {/* Unavailable periods */}
                {t("Unavailable periods")}
              </p>
              <div className="from-to-flex">
                <div className="from-to-box">
                  <p className="available-text">
                    {/* From */}
                    {t("From")}
                  </p>
                  <p className="available-text">
                    {/* To */}
                    {t("To")}
                  </p>
                  <p className="available-text">
                    {/* Reason */}
                    {t("Reason")}
                  </p>
                </div>
              </div>
              <div className="from-to-line"></div>

              <div className="from-to-flex">
                <div
                  className="from-to-box"
                  style={{
                    gridTemplateColumns: "1.5fr 1.5fr 1.3fr",
                    paddingLeft: "0",
                    height: "40px",
                  }}
                >
                  <div className="from-to-cal">
                    <img
                      src={calender}
                      alt="calender"
                      style={{ cursor: "" }}
                      onClick={() => setFromCalendarIsOpen(!fromCalendarIsOpen)}
                    />
                    <AppDatePicker
                      open={fromCalendarIsOpen}
                      onOpenChange={(open) => setFromCalendarIsOpen(open)}
                      selected={DataTemp?.from}
                      onChange={datePickerFuncFrom}
                      dateFormat="dd/MM/yyyy"
                      isError={dateError}
                      error={setDateError}
                      onSelect={(d, event) => {
                        setDateError(false);
                        event.preventDefault();
                      }}
                      isDisabledForPast={true}
                    />
                  </div>

                  <div className="from-to-cal">
                    <img
                      src={calender}
                      alt="calender"
                      style={{ cursor: "" }}
                      onClick={() => setToCalendarIsOpen(!toCalendarIsOpen)}
                    />
                    <AppDatePicker
                      open={toCalendarIsOpen}
                      onOpenChange={(open) => setToCalendarIsOpen(open)}
                      selected={DataTemp?.to}
                      onChange={datePickerFuncTo}
                      dateFormat="dd/MM/yyyy"
                      isError={dateError}
                      error={setDateError}
                      onSelect={(d, event) => {
                        setDateError(false);
                        event.preventDefault();
                      }}
                      isDisabledForPast={true}
                    />
                  </div>
                  <input
                    value={DataTemp?.reason}
                    onChange={(e) => {
                      setDataTemp({
                        ...DataTemp,
                        reason: e.target.value,
                      });
                    }}
                    style={{ border: "none", width: "100%" }}
                  />
                </div>
                <div className="equip-add-box">
                  <FaPlus
                    onClick={() => {
                      if (DataTemp?.from && DataTemp?.to) {
                        setUnavailable([
                          { ...DataTemp, fromOpen: false, toOpen: false },
                          ...unavailable,
                        ]);
                        // setDataTemp({});
                        setDataTemp({ reason: "" });
                      } else {
                        setDateError(true);
                      }
                    }}
                    style={{ color: "white", fontSize: "14px" }}
                  />
                </div>
              </div>
              {unavailable.map((item, index) => {
                return (
                  <>
                    <div className="from-to-line"></div>
                    <div className="from-to-flex">
                      <div
                        className="from-to-box"
                        style={{
                          gridTemplateColumns: "1.5fr 1.5fr 1.3fr",
                          paddingLeft: "0",
                          height: "40px",
                        }}
                      >
                        <div className="from-to-cal">
                          <img
                            src={calender}
                            alt="calender"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              let formedArray = unavailable;
                              formedArray = formedArray.map((x, i) => {
                                if (i === index) {
                                  return x;
                                }
                                return { ...x, fromOpen: false, toOpen: false };
                              });
                              formedArray[index] = {
                                ...formedArray[index],
                                fromOpen: !formedArray[index].fromOpen,
                              };
                              setUnavailable(formedArray);
                            }}
                          />
                          <AppDatePicker
                            open={item?.fromOpen}
                            onOpenChange={(open) => {
                              let formedArray = [...unavailable];

                              formedArray[index] = {
                                ...formedArray[index],
                                fromOpen: open,
                              };

                              setUnavailable(formedArray);
                            }}
                            selected={new Date(item.from || null)}
                            onChange={(val) => {
                              let formedArray = unavailable;
                              formedArray[index] = {
                                ...formedArray[index],
                                from: new Date(val).toISOString(),
                                fromOpen: false,
                              };
                              setUnavailable(formedArray);
                            }}
                            dateFormat="dd/MM/yyyy"
                            isError={dateError}
                            error={setDateError}
                            onSelect={(d, event) => {
                              event.preventDefault();
                              let formedArray = unavailable;
                              formedArray[index] = {
                                ...formedArray[index],
                                from: new Date(d).toISOString(),
                                fromOpen: false,
                              };
                              setUnavailable(formedArray);
                              setDateError(false);
                            }}
                          />
                        </div>
                        <div className="from-to-cal">
                          <img
                            src={calender}
                            alt="calender"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              let formedArray = unavailable;
                              formedArray = formedArray.map((x, i) => {
                                if (i === index) {
                                  return x;
                                }
                                return { ...x, fromOpen: false, toOpen: false };
                              });
                              formedArray[index] = {
                                ...formedArray[index],
                                toOpen: !formedArray[index].toOpen,
                              };
                              setUnavailable(formedArray);
                            }}
                          />
                          <AppDatePicker
                            open={item?.toOpen}
                            onOpenChange={(open) => {
                              let formedArray = [...unavailable];

                              formedArray[index] = {
                                ...formedArray[index],
                                toOpen: open,
                              };

                              setUnavailable(formedArray);
                            }}
                            selected={new Date(item.to || null)}
                            onChange={(val) => {
                              let formedArray = unavailable;
                              formedArray[index] = {
                                ...formedArray[index],
                                to: new Date(val).toISOString(),
                                toOpen: false,
                              };
                              setUnavailable(formedArray);
                            }}
                            dateFormat="dd/MM/yyyy"
                            isError={dateError}
                            error={setDateError}
                            onSelect={(d, event) => {
                              event.preventDefault();
                              let formedArray = unavailable;
                              formedArray[index] = {
                                ...formedArray[index],
                                to: new Date(d).toISOString(),
                                toOpen: false,
                              };
                              setUnavailable(formedArray);
                              setDateError(false);
                            }}
                          />
                        </div>
                        <p className="equip-list-item-text">{item?.reason}</p>
                      </div>
                      <img
                        alt=""
                        onClick={() => {
                          const removedAvailability = unavailable?.filter(
                            (it, id) => id !== index,
                          );
                          setUnavailable(removedAvailability);
                        }}
                        src={bin}
                        style={{ cursor: "pointer", marginRight: "24px" }}
                      />
                    </div>
                  </>
                );
              })}

              <div className="from-to-line"></div>
            </div>
          </div>
        </div>
      </div>

      <EquipmentModal
        animation={true}
        handleDelete={() => history.push("/equipment")}
        show={CancelModal && touched}
        onHide={() => setCancelModal(false)}
        title1={
          // "This data will be removed from the system"
          t("This data will be removed from the system")
        }
        title2={
          // "and cannot be undone."
          t("and cannot be undone.")
        }
        title3={
          "Do you want to proceed?"
          // projectListTranslation[69]?.translation
        }
        no={
          // "No"
          t("No")
        }
        yes={
          // "Yes"
          t("Yes")
        }
      />
    </>
  );
};

export default EquipmentDetails;
